import { gql } from "config/graphql";

export const PAYOUT_DETAILS_FIELDS = gql`
  fragment PayoutDetailsFields on ProductsPayoutDetails {
    autoPedestrian
    generalAccident
    publicTransportation
  }
`;
